import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dialog } from '../../../common/components/dialog';
import { authorizedRequest } from "../../../common/request";
import { Link } from 'react-router-dom'
import AlertDialog from "../../../common/components/alert-dialog"

import "../../style/media-download.scss";
import filesize from 'filesize';
import "../../../common/style/alerts.scss"
class MediaDownloadDialog extends Component {
    constructor(props){
        super(props)
        this.state=this.getInitialState(props)
        this.handleAlbumDataReceived = this.handleAlbumDataReceived.bind(this)
        this.requestDownload = this.requestDownload.bind(this);
        this._ismounted = true;
    }
    getInitialState(props){
        let newState= {
            stats:
            {
                numPhotos: 0,
                numVideos: 0,
                web: { fileSizeLabel: ""},
                src: { fileSizeLabel: ""}
            }
        }
        if(props.type === "cc"){
            newState.stats.numPhotos = props.cc.stats.numPhotos
            newState.stats.numVideos = props.cc.stats.numClips
        }else if(props.type == "cce"){
            newState.stats.numPhotos = props.cce.filter(item => item.elementType === "photo").length
            newState.stats.numVideos = props.cce.filter(item => item.elementType === "video").length
        }else if(props.type == "disc"){
            if(props.disc.discPackageType == "PhotoCdPackage"){
                newState.stats.numPhotos = props.disc.numItems
            }else{
                newState.stats.numVideos = props.disc.numItems
            }
        }

        return newState;
    }
    componentDidMount(){
        setTimeout(this.requestDownload);

    }
    componentWillUnmount() {
        this._ismounted = false;
    }
    requestDownload(){
        if(this.props.type === "cc") {
            authorizedRequest(`${process.env.REACT_APP_WEB_API_URI}/sec/v1/archive/metadata/cc/${this.props.cc.id}`)
                .then(srcData => this.handleAlbumDataReceived(srcData))
                .catch(error => alert("Unable to find information on album " + this.props.cc.id + " error: " + JSON.stringify(error)));
            authorizedRequest(`${process.env.REACT_APP_WEB_API_URI}/sec/v1/archive/cc/${this.props.cc.id}?quality=source`, null, "PUT")
                .then(result => (this.setState({submitted: true, submittedQuality: "source"})))
                .catch(error => alert("There was an error downloading your album: " + JSON.stringify(error)));
        }else if(this.props.type === "disc") {
            let discType = "dvdpkg";
            if (this.props.disc.discPackageType == "PhotoCdPackage") {
                discType = "pcdpkg";
            }
            authorizedRequest(`${process.env.REACT_APP_WEB_API_URI}/sec/v1/archive/${discType}/${this.props.disc.id}?quality=source`, null, "PUT")
                .then(result => (this.setState({submitted: true, submittedQuality: "source"})))
                .catch(error => alert("There was an error downloading your album: " + JSON.stringify(error)));
        }else if(this.props.type === "ccs"){
            for(let i=0;i<this.props.ccs.length;i++){
                authorizedRequest(`${process.env.REACT_APP_WEB_API_URI}/sec/v1/archive/cc/${this.props.ccs[i]}?quality=source`, null, "PUT")
                    .then(result => (this.setState({submitted: true, submittedQuality: "source"})))
                    .catch(error => alert("There was an error downloading your album: " + JSON.stringify(error)))
            }
        }else {
            if(this.props.cce.length === 0){
                return;
            }
            let totalSize = 0;
            for(var i=0;i<this.props.cce.length;i++){
                if(this.props.cce[i].sourceFileSize) {
                    totalSize += this.props.cce[i].sourceFileSize;
                }
            }
            if(totalSize > 0) {
                this.handleAlbumDataReceived({web: {totalPhotoSize:totalSize}, src: {totalPhotoSize:totalSize}})
            }
            let selection = {"imemops.CustomCollectionElement":this.props.cce.map(item => item.id)};
            authorizedRequest(`${process.env.REACT_APP_WEB_API_URI}/sec/v1/archive/selection`, selection, "POST")
                .then(result => (this.setState({submitted:true, submittedQuality:"source"})))
                .catch(error => alert("There was a error setting up your download.  error: " + JSON.stringify(error)))
        }
    }
    handleAlbumDataReceived(srcData){
        this.setState({
            stats: {...this.state.stats,
                web: {fileSizeLabel: filesize(srcData.web.totalPhotoSize)},
                src: {fileSizeLabel:filesize(srcData.src.totalPhotoSize)} }
        })
    }
    render(){
        if(this.props.type === "cce" && this.props.cce.length === 0){
            return (
                <AlertDialog title="Download Media" message="Please select some media first"
                             isOpen={this.props.isOpen}
                             onOkAction={this.props.onClose}/>
            )
        }
        let title = this.props.type == "cc" ? "Download Album" : this.props.type == "cce" ? "Download Items" : this.props.type == "ccs"?"Download Albums": "Download Disc";
        return (
            <Dialog className="download-dialog" title={""}
                    canCancel={true}
                    isOpen={this.props.isOpen}
                    onClose={this.props.onClose}>
                <React.Fragment>
                    <div className="media-download-dialog" style={{display:"flex",flexDirection:"column",alignItems:"center"}}>
                        <img src={require("../../../common/images/download-icon2.svg")} style={{color:"red",width:"40px",heigh:"40px"}} alt="Download Icon"/>
                        <h3>Your Download is Processing</h3>
                        <p>We have added this album to your download queue.  We will send you an email and
                        notify you in your account when your files are ready in your download queue</p>
                        {/*<br/>*/}
                        {/*<MediaQualityOption stats={this.state.stats} quality={"source"}/>*/}
                        {/*<div className="media-download-clearfix"></div>*/}
                        {/*<p>Your download request is processing. An archive file containing your requested media*/}
                        {/*    will be available in a few minutes on the Manage Downloads page.</p>*/}
                        <div className="btn-dialog-container" style={{marginBottom: "16px"}}>
                            <Link to="/my/downloads" className="imem-button imem-button-link primary">GO TO MY DOWNLOAD QUEUE</Link>
                        </div>
                        <p>Downloads can take up to 12 hours to process</p>
                    </div>
                </React.Fragment>
            </Dialog>
        )
    }

}
const MediaQualityOption = (props) => {
    const { stats,quality} = props;
    const goodQualitySizeEstimate = stats.web.fileSizeLabel;
    const highQualitySizeEstimate = stats.src.fileSizeLabel;
    return (
        <div >
            <div className="text-center">
                <img alt={"Image quality "+quality} src={"//static.imemories.com/web-resources/base/images/" + (quality==="web"?"download-modal-computer.jpg":"download-modal-tv.jpg")}/>
            </div>
            <p>{props.quality==="web"?"Good":"High"} Quality</p>
            <div className="download_modal_stats">
                <ul>
                    <li>
                        <span className="stats_label text_light">Formats: </span>
                        <span className="js_format">JPG (photos)</span> <span className="js_format">MP4 (videos)</span>
                    </li>
                    <li>
                        <span className="stats_label text_light">Quantity: </span>
                        <span className="js_num_items">
                            <span className="item_photos">{stats.numPhotos > 0 ? stats.numPhotos + " Photos":"" } </span>
                            <span className="item_videos"> {stats.numVideos > 0 ? stats.numVideos + " Videos":""}</span>
                        </span>
                    </li>
                    {highQualitySizeEstimate !== "" &&
                    <li>
                        <span className="stats_label text_light">File Size: </span>
                        <span
                            className="js_format">{quality === "web" ? goodQualitySizeEstimate : highQualitySizeEstimate}</span>
                    </li>
                    }
                </ul>
            </div>
        </div>
    );
}
MediaDownloadDialog.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    type: PropTypes.string.isRequired,
    cc: PropTypes.object,
    cce: PropTypes.array,
    ccs: PropTypes.array,
    disc: PropTypes.object
};


export default MediaDownloadDialog;


// WEBPACK FOOTER //
// ./src/album-view/components/dialog/media-download-dialog.jsx